import { useStore } from "vuex"
import { computed, onMounted } from 'vue'

export default {
    name: "GroupDetails",
    props: {
        id: {
            type: String,
            required: true
        },
        svgIcon: {
            type: String,
            required: true
        },
        colorTheme: {
            type: String,
            required: false
        },
        title: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: false
        },
        updates: {
            type: Number,
            required: false
        },
        numberOfMembers: {
            type: Number,
            required: false
        },
        numberOfPosts: {
            type: Number,
            required: false
        },
        link: {
            type: String,
            required: true
        },
    },
    setup(props) {
        const store = useStore()

        const statistics = computed(() => store.state.forum.group_statistics[props.id])
        const memberCount = computed(() => statistics.value?.memberCount)
        const postsCount = computed(() => statistics.value?.postsCount)

        onMounted(() => {
            store.dispatch("forum/getGroupStatistics", {
                groupId: props.id
            })
        })

        const handleLeaveGroup = () => {
            store.dispatch('forum/leaveGroup', { 
                groupId: props.id
            })
        }

        return {
            memberCount,
            postsCount,
            handleLeaveGroup,
            getLabel: (labelKey)=> store.getters['labels/getLabel']({labelCollection: "GroupDetails", labelKey: labelKey}),
        }
    }
}